import seed from '../../data/seed.json';
import { LocalStorageRepository } from '../../repositories/LocalStorageRepository.js';
import { scopedStorageKey } from '../../lib/deployment.js';

const SESSION_KEY = scopedStorageKey('sgaee.session.v1');

function mergeUsers(localUsers = []) {
  const merged = new Map();
  [...seed.users, ...localUsers].forEach((user) => {
    if (!user?.email) return;
    merged.set(String(user.email).trim().toLowerCase(), user);
  });
  return Array.from(merged.values());
}

export class MockAuthService {
  constructor(storage = globalThis.localStorage) {
    this.storage = storage;
  }

  getUsers() {
    try {
      const snapshot = new LocalStorageRepository(this.storage).load();
      return mergeUsers(snapshot.users || []);
    } catch {
      return seed.users;
    }
  }

  login(email, password) {
    const normalizedEmail = String(email || '').trim().toLowerCase();
    const user = this.getUsers().find((item) => String(item.email || '').trim().toLowerCase() === normalizedEmail && String(item.password) === String(password));
    if (!user) throw new Error('Usuário ou senha inválidos.');
    const session = { uid: user.uid, email: user.email, nome: user.nome, role: user.role, schoolId: user.schoolId, schoolIds: user.schoolIds || (user.schoolId ? [user.schoolId] : []) };
    this.storage?.setItem(SESSION_KEY, JSON.stringify(session));
    return session;
  }

  logout() {
    this.storage?.removeItem(SESSION_KEY);
  }

  currentUser() {
    const raw = this.storage?.getItem(SESSION_KEY);
    if (!raw) return null;
    try {
      const session = JSON.parse(raw);
      const user = this.getUsers().find((item) => item.uid === session.uid || item.email === session.email);
      if (!user) {
        this.logout();
        return null;
      }
      return { uid: user.uid, email: user.email, nome: user.nome, role: user.role, schoolId: user.schoolId, schoolIds: user.schoolIds || (user.schoolId ? [user.schoolId] : []) };
    } catch {
      this.logout();
      return null;
    }
  }
}
